import { enumToLookupDtos } from '../../../../app/utils/enumHelpers';

export enum AboriginalGroup {
  NorthAmericanIndianFirstNation = 0,
  Inuit = 1,
  Métis = 2,
}

export enum DisabilityType {
  CoordinationOrDexterity = 0,
  Mobility = 1,
  BlindOrVisualImpairment = 2,
  DeafOrHardOfHearing = 3,
  SpeechImpairment = 4,
  OtherDisabilityType = 5,
}

export enum MinorityGroup {
  Black = 0,
  Chinese = 1,
  Filipino = 2,
  Japanese = 3,
  Korean = 4,
  SouthAsianEastIndian = 5,
  SoutheastAsian = 6,
  NonWhiteWestAsianNorthAfricanOrArab = 7,
  NonWhiteLatinAmerican = 8,
  PersonOfMixedOrigin = 9,
  OtherVisibleMinorityGroup = 10,
}

export const AboriginalGroupLookups = enumToLookupDtos(AboriginalGroup);
export const DisabilityTypeLookups = enumToLookupDtos(DisabilityType);
export const MinorityGroupLookups = enumToLookupDtos(MinorityGroup);
